import { Action } from '@ngrx/store';
import { ViewContainerRef } from '@angular/core';

export class ClearDepotUnloadActionIds implements Action {
  readonly type = DepotActionTypes.CLEAR_DEPOT_UNLOAD_ACTION_IDS;
}

export class InitUnloadAtDepot implements Action {
  readonly type = DepotActionTypes.INIT_UNLOAD_AT_DEPOT;

  constructor(public payload: { actionIds: number[]; dialogInsertion: ViewContainerRef }) {}
}

export enum DepotActionTypes {
  INIT_UNLOAD_AT_DEPOT = 'INIT_UNLOAD_AT_DEPOT',
  CLEAR_DEPOT_UNLOAD_ACTION_IDS = 'CLEAR_DEPOT_UNLOAD_ACTION_IDS'
}

export type DepotActions = InitUnloadAtDepot | ClearDepotUnloadActionIds;
